import { PushNotifications } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';

class PushNotificationService {
  constructor() {
    this.isInitialized = false;
    this.pushToken = null;
    this.onTokenReceived = null;
    this.onNotificationReceived = null;
    this.onNotificationOpened = null;
  }

  async initialize() {
    if (this.isInitialized) {
      return;
    }

    // Nur auf nativen Plattformen verfügbar
    if (!Capacitor.isNativePlatform()) {
      console.log('Push Notifications sind nur auf nativen Plattformen verfügbar');
      return;
    }

    try {
      // Berechtigung anfragen
      const permission = await PushNotifications.requestPermissions();
      
      if (permission.receive === 'granted') {
        console.log('Push Notification Berechtigung erhalten');
        
        // Für Push-Benachrichtigungen registrieren
        await PushNotifications.register();
        
        // Event Listeners hinzufügen
        this.addEventListeners();
        
        this.isInitialized = true;
      } else {
        console.log('Push Notification Berechtigung verweigert');
      }
    } catch (error) {
      console.error('Fehler beim Initialisieren der Push Notifications:', error);
    }
  }

  addEventListeners() {
    // Listener für erfolgreiche Registrierung
    PushNotifications.addListener('registration', (token) => {
      console.log('Push Registration Token erhalten:', token.value);
      this.pushToken = token.value;
      
      if (this.onTokenReceived) {
        this.onTokenReceived(token.value);
      }
    });

    // Listener für Registrierungsfehler
    PushNotifications.addListener('registrationError', (error) => {
      console.error('Push Registration Fehler:', error);
    });

    // Listener für empfangene Push-Benachrichtigungen (App im Vordergrund)
    PushNotifications.addListener('pushNotificationReceived', (notification) => {
      console.log('Push Notification empfangen:', notification);
      
      if (this.onNotificationReceived) {
        this.onNotificationReceived(notification);
      }
    });

    // Listener für geklickte Push-Benachrichtigungen
    PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
      console.log('Push Notification geklickt:', notification);
      
      if (this.onNotificationOpened) {
        this.onNotificationOpened(notification);
      }
    });
  }

  // Callback-Funktionen setzen
  setOnTokenReceived(callback) {
    this.onTokenReceived = callback;
  }

  setOnNotificationReceived(callback) {
    this.onNotificationReceived = callback;
  }

  setOnNotificationOpened(callback) {
    this.onNotificationOpened = callback;
  }

  // Push Token abrufen
  getPushToken() {
    return this.pushToken;
  }

  // Alle gelieferten Benachrichtigungen abrufen
  async getDeliveredNotifications() {
    try {
      const notificationList = await PushNotifications.getDeliveredNotifications();
      return notificationList.notifications;
    } catch (error) {
      console.error('Fehler beim Abrufen der gelieferten Benachrichtigungen:', error);
      return [];
    }
  }

  // Gelieferte Benachrichtigungen entfernen
  async removeDeliveredNotifications(ids) {
    try {
      await PushNotifications.removeDeliveredNotifications({
        notifications: ids.map(id => ({ id }))
      });
      console.log('Benachrichtigungen entfernt:', ids);
    } catch (error) {
      console.error('Fehler beim Entfernen der Benachrichtigungen:', error);
    }
  }

  // Alle gelieferten Benachrichtigungen entfernen
  async removeAllDeliveredNotifications() {
    try {
      await PushNotifications.removeAllDeliveredNotifications();
      console.log('Alle Benachrichtigungen entfernt');
    } catch (error) {
      console.error('Fehler beim Entfernen aller Benachrichtigungen:', error);
    }
  }
}

// Singleton-Instanz exportieren
export const pushNotificationService = new PushNotificationService();
